var React = require('react');

function BlueCheck (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/check_circle"},[React.createElement("path",{"id":"Vector","d":"M10.0003 1.66667C5.40033 1.66667 1.66699 5.4 1.66699 10C1.66699 14.6 5.40033 18.3333 10.0003 18.3333C14.6003 18.3333 18.3337 14.6 18.3337 10C18.3337 5.4 14.6003 1.66667 10.0003 1.66667ZM8.33366 14.1667L4.16699 10L5.34199 8.825L8.33366 11.8083L14.6587 5.48333L15.8337 6.66667L8.33366 14.1667Z","fill":"#0F6FDE","key":0}),React.createElement("path",{"id":"Vector_2","d":"M8.33268 14.1667L4.16602 9.99998L5.34102 8.82499L8.33268 11.8083L14.6577 5.48332L15.8327 6.66665L8.33268 14.1667Z","fill":"white","key":1})]));
}

BlueCheck.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = BlueCheck;

BlueCheck.default = BlueCheck;
